import { UserInfoFI } from "@/components/HolderForm/UserInfoFI.ts";
import { UserInfoFormValues } from "@/components/HolderForm/UserInfoFormValues.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";

export const useHolderInfoForm = () => {
  const reservationHolderData = useEngineStore((s) => s.reservationHolderData);
  const setReservationHolderData = useEngineStore((s) => s.setReservationHolderData);
  const isResetting = useRef(false);
  const isFromWatch = useRef(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    watch,
    trigger,
    reset,
    getValues,
    setFocus,
  } = useForm<UserInfoFormValues>({ mode: "onChange", defaultValues: reservationHolderData ?? undefined });

  const watchFirstName = watch([UserInfoFI.FirstName])[0];
  const watchLastName = watch([UserInfoFI.LastName])[0];

  // Rehydrate form from store — but skip when the store was just updated by our own watch subscription,
  // otherwise the reset destroys DOM values that Chrome autofill wrote but RHF hasn't picked up yet.
  useEffect(() => {
    if (isFromWatch.current) {
      isFromWatch.current = false;
      return;
    }
    if (reservationHolderData) {
      isResetting.current = true;
      reset(reservationHolderData);
      isResetting.current = false;
    }
  }, [reservationHolderData, reset]);

  useEffect(() => {
    const subscription = watch((values) => {
      if (!isResetting.current) {
        isFromWatch.current = true;
        setReservationHolderData(values as UserInfoFormValues);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, setReservationHolderData]);

  return {
    holderFormData: {
      register,
      handleSubmit,
      errors,
      isValid,
      setValue,
      watch,
      trigger,
      reset,
      getValues,
      setFocus,
    },
    watchFirstName,
    watchLastName,
  };
};
